// extracted by mini-css-extract-plugin
module.exports = {"container":"CartHeader_container__38yrb","quantity":"CartHeader_quantity__9OIAY","icon":"CartHeader_icon__-L61c","bump":"CartHeader_bump__ikTZb"};